import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  createCountryCodeOptions,
  FormProvider,
  FormSelect,
} from "@inductiveautomation/ws-components";

import { useMutations } from "../hooks/useMutations";

const ProfileCountryField = ({
  defaultValue,
}: {
  defaultValue: string | null | undefined;
}) => {
  const { t } = useTranslation("translation", { keyPrefix: "profile" });
  const { t: translateCountries } = useTranslation("countries");

  const countryCodeOptions = useMemo(
    () => createCountryCodeOptions(translateCountries),
    [translateCountries]
  );

  const { updateProfileField } = useMutations();

  const formMethods = useForm({
    defaultValues: { country: defaultValue },
  });
  const onSubmit = formMethods.handleSubmit((data) => {
    if (data.country !== defaultValue) {
      void updateProfileField("country", data.country ?? "");
    }
  });

  return (
    <FormProvider {...formMethods}>
      <form
        onBlur={(event) => void onSubmit(event)}
        onSubmit={(event) => event.preventDefault()}
      >
        <FormSelect
          prefix="profile"
          name="country"
          label={t("form.labels.country")}
          options={countryCodeOptions}
        />
      </form>
    </FormProvider>
  );
};

export default ProfileCountryField;
